export default __webpack_public_path__ + "static/media/Solutions_Stores_Logo@2x.ce5e2f4c.png";